import moment from 'moment'

const FlightDate = ({...props}) => {
  const date = props.date
  return moment.utc(date, "YYYY-MM-DDTHH:mm:ss").format("DD/MM/YYYY LT")
}

export default FlightDate



// WEBPACK FOOTER //
// ./src/component/FlightDate.js